import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["files", "emptyDescription"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuDownloadFileButton from "../DixuDownloadFileButton/DixuDownloadFileButton";
import DixuEmpty from "../DixuEmpty/DixuEmpty";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuModal from "../DixuModal/DixuModal";
import DixuText from "../DixuText/DixuText";
import React from 'react';
const DixuDownloadFilesModal = _ref => {
  let {
      files,
      emptyDescription
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const filesByCategory = files.reduce((acc, cur) => {
    const {
      category,
      items
    } = cur;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [category]: [...(acc[category] || []), ...items]
    });
  }, {});
  const mappedFiles = Object.entries(filesByCategory).sort((a, b) => {
    return a[0].localeCompare(b[0]);
  }).map(_ref2 => {
    let [category, items] = _ref2;
    const mappedItems = items.sort((a, b) => {
      return a.name.localeCompare(b.name);
    }).sort((a, b) => {
      return Number(!!b.thumbnail) - Number(!!a.thumbnail);
    }).map((item, index) => {
      const {
        thumbnail,
        name,
        url
      } = item;
      return /*#__PURE__*/React.createElement(DixuCol, {
        key: index.toString(36),
        span: 24
      }, /*#__PURE__*/React.createElement(DixuDownloadFileButton, {
        downloadName: name,
        thumbnail: thumbnail,
        url: url,
        block: true
      }, name));
    });
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: category,
      span: 24
    }, /*#__PURE__*/React.createElement(DixuRow, {
      gutter: [0, 8]
    }, /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, /*#__PURE__*/React.createElement(DixuText, {
      font: "3",
      color: "2-7",
      weight: "bold"
    }, category)), /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, /*#__PURE__*/React.createElement(DixuRow, {
      gutter: [0, 8]
    }, mappedItems))));
  });
  return /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    width: 582
  }), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [0, 16]
  }, mappedFiles.length ? mappedFiles : /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuEmpty, {
    description: emptyDescription
  }))));
};
DixuDownloadFilesModal.defaultProps = {
  files: [],
  emptyDescription: null
};
export default DixuDownloadFilesModal;